import React, { useState, useEffect, useMemo } from "react";
import { observer } from "mobx-react-lite";
import FormControl from "@material-ui/core/FormControl";
import FormGroup from "@material-ui/core/FormGroup";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import { runInAction } from "mobx";
import { InvoiceFieldsNew } from "../InvoiceFieldsNew/InvoiceFieldsNew";
import { toJS } from "mobx";
import EventLabel from "../../components/EventLabel";
import { CountrySelect } from "../CountrySelect/CountrySelect";
import PersonOutline from "@material-ui/icons/PersonOutline";
import Ballot from "@material-ui/icons/Ballot";
import ReceiptIcon from "@material-ui/icons/Receipt";
import CreditCardIcon from "@material-ui/icons/CreditCard";
import { deepClone } from "../../helpers/objectHelper";
import { getCalculatedOrderRow } from "../OrderSummary/components/ConfirmationOrderRow";
import { useRef } from "react";

const PaymentOptionsNew = (props) => {
  const invoiceAnchor = useRef();
  const [selectedCountry, setSelectedCountry] = useState("");
  const [regionGroup, setRegionGroup] = useState("");
  const [currentOptions, setCurrentOptions] = useState([""]);
  const [currentType, setCurrentType] = useState("");
  const [ix, setIx] = useState("");
  const [selectedCountryCode, setSelectedCountryCode] = useState("");
  const [fixedCountry, setFixedCountry] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);

  const { settings, addOrUpdate, activePersonNo, orders, updateOrder, current, contentModuleId, validations, checkHeights, environment, eventId, mainEvent, setValidatePaymentFields, validatePaymentFields } = props;

  const [paymentMethods, setPaymentMethods] = useState([]);
  const [selectedOption, setSelectedOption] = useState("");

  const orderList = useMemo(() => toJS(orders), [orders]);

  const setLoad = (b) => setIsLoaded(b);
  const findLeader = () => {
    var v = orderList.find((o) => o.leader);
    if (!v) {
      v = orderList.find((o) => o.orderId == o.orderGroupId);
    }
    if (v) {
      return orderList.indexOf(v);
    } else {
      return 0;
    }
  };

  useEffect(() => {
    if (validatePaymentFields) {
      var val = validations.find((v) => v.label == "PaymentOption");
      if (val) {
        runInAction(() => {
          val.valid = false;
        });
      }
    }
  }, [validatePaymentFields]);

  //Test loading with different Leader and different ActivePersonNo, both were they're == and !=
  //also useMemo on countryselect
  useEffect(() => {
    var no = findLeader();
    var no2 = findLeader();
    let isTemp = orderList.find((o) => o.isActive == "temp") ? true : false;
    if ((orderList[no]?.orderId || isTemp) && orderList[no]?.invoice) {
      if (!orderList[no].invoice) {
        no = no2;
      }
      var orderInvoiceArray = Object.keys(orderList[no].invoice).map((key) => ({
        name: key,
        value: orderList[no].invoice[key],
      }));
      var empty = orderInvoiceArray.filter((a) => a.value == null);
      var pt = orderList[no].invoice == {} || empty.length > 10 ? "dibs" : "invoice";
      var pm = orderList[no].invoice.telephone1 ? "comgov" : "person";

      if (no != no2) {
        runInAction(() => {
          props.activePersonNo = no2;
        });
      }
      if (pt != "dibs" || pt != "stripe") {
        setCurrentType(pm);
        setSelectedOption(pt);
      }

      if (orderList[no]?.invoice?.countryCode) {
        setSelectedCountryCode(orderList[no].invoice.countryCode);
      }
    }
  }, []);

  useEffect(() => {
    if (selectedOption != "") {
      runInAction(() => {
        current.payMethod = selectedOption;
      });
    }
  }, [selectedOption]);

  useEffect(() => {
    if (orderList[activePersonNo]?.orderId || orderList[activePersonNo]?.isActive) {
      return;
    }

    setCurrentType("");
    setSelectedOption("");
    setPaymentMethods([]);
    if (settings.paymentGrid["only"] && settings.paymentGrid["only"].length == 1) {
      let t = settings.paymentGrid["only"][0].countries[0];
      onCountry(t.value, t);
      setLoad(true);
      setFixedCountry(true);
    } else {
      setFixedCountry(false);
    }
  }, [selectedCountry]);

  useEffect(() => {
    if (orderList[activePersonNo]?.orderId || orderList[activePersonNo]?.isActive) {
      return;
    } //test
    if (currentOptions.length == 1) {
      if (selectedCountry != "") {
        setRegionGroup(regionGroup);
        setSelectedCountry(selectedCountry);
        setCurrentType(currentOptions[0]);
        setCurrentOptions([]); //test
      }
    }
  }, [selectedCountry, currentOptions]);

  const onCountry = (target, a, r = false) => {
    if (a == selectedCountry) {
      return;
    }

    let prefix = a?.name?.toLowerCase();

    setRegionGroup(prefix);
    setSelectedCountry(a);
    setIx(target);

    var val = validations.find((v) => v.label == "PaymentOption");
    if (val && val?.valid) {
      runInAction(() => {
        val.valid = false;
      });
    }

    let data = toJS(settings.paymentGrid);
    let opts = data[prefix];
    if (opts == undefined) {
      opts = data["global"];
      prefix = "global";
    }
    if (opts !== undefined) {
      let options = [];
      if (opts.includes("comgov")) {
        if (data[prefix + " dibs comgov"] || data[prefix + " invoice comgov"] || data[prefix + " stripe comgov"]) {
          options.push("comgov");
        }
      }
      if (opts.includes("person")) {
        if (data[prefix + " dibs person"] || data[prefix + " invoice person"] || data[prefix + " stripe person"]) {
          options.push("person");
        }
      }

      setCurrentOptions(options);
    } else {
      setCurrentOptions([]);
    }

    if ((!orderList[activePersonNo]?.orderId && !orderList[activePersonNo]?.isActive) || r) {
      setSelectedOption("");
      setCurrentType("");
    }
    if (r) {
      runInAction(() => {
        orderList[activePersonNo].invoice = {};
        // delete orders[activePersonNo].orderId;
        updateOrder(orderList[activePersonNo]);
      });
    }
  };
  //what happens when we select dibs/invoice
  const onPaymentMethod = (m, d = null) => {
    setSelectedOption(m);
    var no = activePersonNo;
    var no2 = findLeader();
    if (!orderList[no]?.orderId) {
      no = no2;
    }
    if (!orderList[no]?.orderId) {
      runInAction(() => {
        let tempOrder = deepClone(orderList[no]);
        tempOrder.invoice = {};
        updateOrder(tempOrder, no);
      });
    }

    var currentPT = currentType;
    var data = settings.paymentGrid;
    var prefix = "";
    if (data["exceptions"].includes(selectedCountry?.name)) {
      prefix = selectedCountry.name.toLowerCase();
    } else {
      prefix = "global";
    }

    if (currentType == "comgov") {
      let pms = [];
      if (data[prefix + " " + m + " comgov"]) {
        pms.push("comgov");
      }
      if (pms.length == 1) {
        currentPT = pms[0];
        setCurrentType(currentPT);
      }
    }
  };

  useEffect(() => {
    if (currentType == "" || selectedCountry == "") {
      return;
    }

    if (!orderList[activePersonNo]?.orderId && !orderList[activePersonNo]?.isActive) {
      setSelectedOption("");
    }

    var data = settings.paymentGrid;
    var prefix = "";

    if (data["exceptions"].includes(selectedCountry?.name?.toLowerCase())) {
      prefix = selectedCountry.name.toLowerCase();
    } else {
      prefix = "global";
    }

    if (currentType == "person") {
      let l = [];
      if (data[prefix + " dibs person"]) {
        l.push("dibs");
      }
      if (data[prefix + " invoice person"]) {
        l.push("invoice");
      }
      if (data[prefix + " stripe person"]) {
        l.push("stripe");
      }

      setPaymentMethods(l);
      if (l.length == 1) {
        onPaymentMethod(l[0]);
      }
    } else if (currentType == "comgov") {
      let l = [];
      if (data[prefix + " dibs comgov"]) {
        l.push("dibs");
      }
      if (data[prefix + " invoice comgov"]) {
        l.push("invoice");
      }
      if (data[prefix + " stripe comgov"]) {
        l.push("stripe");
      }
      setPaymentMethods(l);
      if (l.length == 1) {
        onPaymentMethod(l[0]);
      }
    }

    const module = props.contentLayout.contentLayoutModules.find((clm) => clm.contentLayoutModuleId == props.contentLayoutModuleId);
    var newOrders = deepClone(toJS(orderList));
    if (newOrders.length > 0) {
      var targetOrder = newOrders.find((a) => a.leader);
      if (!targetOrder) {
        targetOrder = newOrders[0];
      }
      var index = newOrders.indexOf(targetOrder);
      if (targetOrder.invoice) {
        if (targetOrder.invoice.countryId) {
          setIx(targetOrder.invoice.countryId);
          delete targetOrder.invoice.countryId;
        }
        if (targetOrder.invoice.countryCode) {
          setSelectedCountryCode(targetOrder.invoice.countryCode);
        }
      }
      runInAction(() => {
        module.height = 150;
        updateOrder(targetOrder, index);
      });
    }
  }, [currentType, currentOptions]);

  const expand = (option) => {
    const module = props.contentLayout.contentLayoutModules.find((clm) => clm.contentLayoutModuleId == props.contentLayoutModuleId);
    const validity = validations.find((v) => v.id == contentModuleId);
    if (!module) return;
    let optionChanged = Boolean(current.payMethod !== option);
    runInAction(() => {
      current.payMethod = option;
      validity.valid = true;
    });
    if (optionChanged) {
      checkHeights();
    }
  };

  useEffect(() => {
    //make stuff work if selecting only 'free' events
    var flatOrderRowsList = orderList
      .map((o) => {
        if (o.orderRow) return [...o.orderRow.map((or) => getCalculatedOrderRow(or, props.breakouts, orderList, o.orderId, props.mainEvent, props.modules))];
      })
      .flat();

    const total =
      flatOrderRowsList
        ?.filter((item) => item?.orderRowId < 0 && item?.amount > 0)
        ?.map((item) => item?.amount - item?.discountAmount)
        ?.reduce((prev, next) => prev + next, 0) || 0;

    const shouldValidate = !(total === 0);
    if (validatePaymentFields !== shouldValidate) {
      setValidatePaymentFields(shouldValidate);
    }
    checkHeights();
  });

  if (settings.hidden) return null;
  if (!validatePaymentFields) return <div style={{ height: "1px" }}></div>;

  return (
    <>
      <div className="cms-field invoice form-group">
        {!fixedCountry ? (
          <>
            <div className="title-holder">
              <label>
                <EventLabel name={"SelectCountry"} groupName={"CMS.Payment"} />
              </label>
            </div>
            <CountrySelect
              loaded={(b) => setLoad(b)}
              value={ix}
              eventId={environment.eventId}
              lang={environment.lang}
              onChange={(e, a, t) => onCountry(e, a, true)}
              selectGrid={settings.paymentGrid}
              useCode
              countryCode={selectedCountry?.countryCode}
              preselected={props?.defaultSelectedCountry || 206}
            />
          </>
        ) : null}
      </div>
      <FormControl className="type-col">
        {selectedCountry != "" && currentOptions.length > 0 ? (
          <FormGroup key="pt" className="type-row" style={{ padding: "10px 0" }}>
            {currentOptions.length > 0 &&
              currentOptions
                .slice()
                .sort()
                .map((p) => {
                  return (
                    <React.Fragment key={p}>
                      <PaymentOptionButton
                        {...{
                          option: p,
                          selectedOption: currentType,
                          selectOption: () => {
                            setRegionGroup(regionGroup);
                            setSelectedCountry(selectedCountry);
                            setCurrentType(p);
                          },
                        }}
                      />
                    </React.Fragment>
                  );
                })}
            {/* {currentType === "" && <EventLabel name={"NoPayment"} groupName={"CMS.Payment"} />} */}
          </FormGroup>
        ) : null}

        {selectedCountry != "" && currentOptions.length == 0 && paymentMethods.length == 0 ? (
          <label>
            <EventLabel name={"NoPayment"} groupName={"CMS.Payment"} />
          </label>
        ) : null}

        {paymentMethods.length > 1 ? (
          <FormGroup key="pm" className="type-row" style={{ padding: "10px 0" }}>
            {paymentMethods
              .slice()
              .sort()
              .map((pm) => {
                return (
                  <React.Fragment key={pm}>
                    <PaymentMethodButton
                      {...{
                        option: pm,
                        selectedOption,
                        selectOption: () => {
                          expand(pm);
                          onPaymentMethod(pm);
                        },
                      }}
                    />
                  </React.Fragment>
                );
              })}
          </FormGroup>
        ) : null}
      </FormControl>
      {currentType != "" && selectedOption != "" && isLoaded ? (
        <div className="invoice-fields">
          <InvoiceFieldsNew {...{ ...props, regionGroup, currentType, selectedCountry, paymentMethods, selectedOption, setSelectedOption, invoiceAnchor, mainEvent, validatePaymentFields }} />
        </div>
      ) : null}

      <div id="invoiceScrollAnchor" ref={invoiceAnchor}></div>
    </>
  );
};

export default observer(PaymentOptionsNew);

const PaymentOptionButton = ({ option, selectOption, selectedOption }) => {
  switch (option) {
    case "person":
      return (
        <div className="payment-button-wrap">
          <button onClick={selectOption} className={"payment-button" + (selectedOption == option ? " active" : "")}>
            {selectedOption == option ? <CheckCircleIcon className="selected-payment-option" /> : null}
            <PersonOutline />
          </button>
          <div style={{ textAlign: "center", display: "flex", justifyContent: "center" }}>
            <EventLabel name={"PersonType"} groupName={"CMS.Payment"} />
          </div>
        </div>
      );

    case "comgov":
      return (
        <div className="payment-button-wrap">
          <button onClick={selectOption} className={"payment-button" + (selectedOption == option ? " active" : "")}>
            {selectedOption == option ? <CheckCircleIcon className="selected-payment-option" /> : null}
            <Ballot />
          </button>
          <div style={{ textAlign: "center", display: "flex", justifyContent: "center" }}>
            <EventLabel name={"ComgovType"} groupName={"CMS.Payment"} />
          </div>
        </div>
      );

    default:
      return null;
  }
};

const PaymentMethodButton = ({ option, selectOption, selectedOption }) => {
  switch (option) {
    case "invoice":
      return (
        <div className="payment-button-wrap">
          <button onClick={selectOption} className={"payment-button" + (selectedOption == option ? " active" : "")}>
            {selectedOption == option ? <CheckCircleIcon className="selected-payment-option" /> : null}
            <ReceiptIcon />
          </button>
          <div style={{ textAlign: "center", display: "flex", justifyContent: "center" }}>
            <EventLabel name={"InvoicePayment"} groupName={"CMS.Payment"} />
          </div>
        </div>
      );

    case "stripe":
      return (
        <div className="payment-button-wrap">
          <button onClick={selectOption} className={"payment-button" + (selectedOption == option ? " active" : "")}>
            {selectedOption == option ? <CheckCircleIcon className="selected-payment-option" /> : null}
            <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/b/ba/Stripe_Logo%2C_revised_2016.svg/1280px-Stripe_Logo%2C_revised_2016.svg.png" style={{ width: "50px" }} alt="Stripe" />
          </button>
          <div style={{ textAlign: "center", display: "flex", justifyContent: "center" }}>
            <EventLabel name={"CardPaymentOnly"} groupName={"CMS.Payment"} />
          </div>
        </div>
      );

    case "dibs":
      return (
        <div className="payment-button-wrap">
          <button onClick={selectOption} className={"payment-button" + (selectedOption == option ? " active" : "")}>
            {selectedOption == option ? <CheckCircleIcon className="selected-payment-option" /> : null}
            <CreditCardIcon />
          </button>
          <div style={{ textAlign: "center", display: "flex", justifyContent: "center" }}>
            <EventLabel name={"CardPayment"} groupName={"CMS.Payment"} />
          </div>
        </div>
      );

    default:
      return <EventLabel name={"NoPayment"} groupName={"CMS.Payment"} />;
  }
};
